import { styled } from 'baseui'

export const Card = styled('article', ({ $theme }) => ({
  flexShrink: 0,
  overflow: 'hidden',
  backgroundColor: $theme.colors.white,
  borderLeft: `0.25rem solid ${$theme.colors.warning}`,
  borderRadius: $theme.borders.radius300,
  boxShadow: $theme.lighting.shadow600,
}))

export const CardHeader = styled('header', ({ $theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '0.75rem',
  padding: '0.75rem 1rem',
  backgroundColor: $theme.colors.warningBg,
}))

export const IconBubble = styled('span', ({ $theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: '2.25rem',
  height: '2.25rem',
  borderRadius: '50%',
  backgroundColor: $theme.colors.white,
  color: $theme.colors.warning,
}))

export const HeaderText = styled('div', {
  flexGrow: 1,
  minWidth: 0,
})

export const CardTitle = styled<'h3', { $isLate: boolean }>('h3', ({ $theme, $isLate }) => ({
  margin: 0,
  fontSize: '1rem',
  fontWeight: 600,
  color: $isLate ? $theme.colors.warning : $theme.colors.textHeading,
}))

export const CardSubtitle = styled('p', ({ $theme }) => ({
  margin: '0.125rem 0 0',
  fontSize: '0.75rem',
  color: $theme.colors.textMuted,
}))

export const CloseButton = styled('button', ({ $theme }) => ({
  display: 'inline-flex',
  flexShrink: 0,
  padding: '0.25rem',
  border: 'none',
  backgroundColor: 'transparent',
  color: $theme.colors.textMuted,
  cursor: 'pointer',
  ':disabled': {
    cursor: 'not-allowed',
  },
}))

export const CardBody = styled('div', {
  padding: '1rem',
})

export const CustomerName = styled('p', ({ $theme }) => ({
  margin: 0,
  fontSize: '1.125rem',
  fontWeight: 600,
  color: $theme.colors.textHeading,
}))

export const CustomerPhone = styled('p', ({ $theme }) => ({
  margin: '0.5rem 0 1rem',
  fontSize: '1rem',
  color: $theme.colors.textHeading,
}))

export const CallStatus = styled<'p', { $failed: boolean }>('p', ({ $theme, $failed }) => ({
  margin: '0.5rem 0 0.75rem',
  fontSize: '0.875rem',
  color: $failed ? $theme.colors.negative600 : $theme.colors.textMuted,
}))
